import { GET_ALL_QUICK_LINKS, QUICK_LINK_COUNT } from '../actions/QuickLinksActions';
import { reducerWrapper } from '../support/utils';

const INIT_STATE = {
  loading: false,
  error: null,
  data: null,
  link_count: 0,
  links: [],
};

function Handler(state, action) {
  switch (action.type) {
    case QUICK_LINK_COUNT.response:
      return { ...state, link_count: action.data };

    case GET_ALL_QUICK_LINKS.response:
      return { ...state, links: [...state.links, ...action.data], loading: false };

    default:
      return state;
  }
}

const QuickLinksReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [QUICK_LINK_COUNT, GET_ALL_QUICK_LINKS],
  error: [QUICK_LINK_COUNT, GET_ALL_QUICK_LINKS],
  resetOn: ['APP_CHANGE'],
});
export default QuickLinksReducer;
